import { useAccountStore } from '@/store/modules/account/store.js';
import { useUserStore } from '@/store/modules/user/store.js';
import { useContextStore } from '@/store/modules/context/store.ts';
import { useDashboardContextStore } from '@/store/modules/dashboardContext/store.ts';
import { useDashboardColumnsStore } from '@/store/modules/dashboardColumns/store.ts';
import DashboardType from '../../../entities/DashboardType.js';
import DashboardView from '../../../entities/DashboardView.js';
import ActivixDate from '../../../value-objects/ActivixDate.js';

export default {
    // Proxy getters - delegate to dashboardContextStore
    configs() {
        return useDashboardContextStore().configs;
    },
    startDate() {
        return useDashboardContextStore().startDate;
    },
    endDate() {
        return useDashboardContextStore().endDate;
    },
    dashboardType() {
        return useDashboardContextStore().dashboardType;
    },

    division() {
        const dashboardType = this.dashboardType;
        let tmpDivision;

        if (empty(dashboardType)) {
            return [];
        }

        if (dashboardType == 'service') {
            return ['service'];
        }

        if (!empty(this.configs.filters)) {
            tmpDivision = this.configs.filters['division:name'];
        }

        if (empty(tmpDivision)) {
            return [];
        }

        return tmpDivision;
    },

    dashboardDisabledForGroups() {
        const groupIsSelected = !!useContextStore().group.id;
        const parentAccountIsSelected = useAccountStore().contextAccount.account_manager;

        if (!groupIsSelected && !parentAccountIsSelected) {
            return false;
        }

        if ([DashboardType.SALE, DashboardType.EVENT].includes(this.dashboardType)) {
            return true;
        }

        if ([DashboardType.ACTIVITY].includes(this.dashboardType) && groupIsSelected) {
            return true;
        }

        return false;
    },

    getDashboardView() {
        return (viewId) => {
            for (const views of Object.values(this.dashboardViews)) {
                const view = views.find((v) => v.id == viewId);

                if (view) {
                    return view;
                }
            }

            return {};
        };
    },

    dashboardView() {
        if (
            this.selectedDashboardView &&
            this.selectedDashboardView.dashboard == this.dashboardType &&
            (this.selectedDashboardView.user_id == useUserStore().parentAuthUser.id ||
                this.selectedDashboardView.is_shared)
        ) {
            if (this.notificationDate) {
                this.selectedDashboardView.filter.renewal_alert_date = new ActivixDate(
                    this.notificationDate
                ).format(ActivixDate.DATE_HUMAN_SHORT_FORMAT);
            }

            return new DashboardView(this.selectedDashboardView);
        }

        return new DashboardView();
    },

    dashboardCriteria() {
        return {
            accountId: useAccountStore().contextAccountId,
            dashboard: this.dashboardType,
            divisions: this.division,
            startDate: new ActivixDate(this.startDate).startOfDay().toDateTimeString(),
            endDate: new ActivixDate(this.endDate).endOfDay().toDateTimeString(),
            filteredCampaigns: this.filteredCampaigns,
            filteredDates: this.filteredDates,
            filters: this.activeDashboardFilters,
            groupId: useContextStore().groupId || undefined,
            options: this.configs.options,
            orderBy: this.pagination.orderBy,
            sortBy: this.pagination.sortBy,
            userId: useContextStore().userId || undefined,
            teamId: useContextStore().teamId || undefined,
        };
    },

    activeDashboardFilters() {
        return useDashboardColumnsStore()
            .dashboardColumns.filter((column) => {
                return column.visible || column.mandatory;
            })
            .reduce((filters, column) => {
                const value = this.configs.filters[column.name];

                if (empty(value)) {
                    return filters;
                }

                filters[column.name] = value;

                return filters;
            }, {});
    },

    isMassMailing() {
        if (this.allLeadsInTableSelected) {
            return true;
        }

        return this.bulkSelect.filter((lead) => !!lead.emails?.length).length > 1;
    },

    isMassSms() {
        if (this.allLeadsInTableSelected) {
            return true;
        }

        return this.bulkSelect.filter((lead) => !!lead.getSmsCandidatePhones().length).length > 1;
    },

    isMassCommunication() {
        return this.isMassMailing || this.isMassSms;
    },
};
